import { queryOptions } from '@tanstack/react-query';

import { ONE_MINUTE } from '@/constants/time';
import { fetchClient } from '@/util/fetchClient';

export type UserAvatarUrlLookup = Awaited<
  ReturnType<typeof getUserAvatarUrlsV2>
>['userAvatarUrlLookup'];

export async function getUserAvatarUrlsV2(userIds: number[]) {
  // const { data } = await fetchClient.POST('/v2/users/avatar-urls', {
  //   body: {
  //     userIds,
  //   },
  // });
  const { data } = await fetchClient.GET('/v2/users/avatar-urls', {
    params: {
      query: {
        userIds: userIds.join(','),
      },
    },
  });

  const userIdsWithAvatarUrls = data?.data || [];

  const userAvatarUrlLookup = new Map(userIdsWithAvatarUrls.map((item) => [item.id, item.avatar]));

  return {
    userAvatarUrlLookup,
    userIdsWithAvatarUrls,
  };
}

export const getUserAvatarUrlsV2QueryOptions = (userIds: number[] | string[]) =>
  queryOptions({
    queryKey: ['usersAvatarUrlsV2', userIds],
    queryFn: () => getUserAvatarUrlsV2(userIds.map(Number)),
    staleTime: ONE_MINUTE,
    enabled: !!userIds,
  });
